import { ButtonBase, Popover, Stack } from "@mui/material"
import { colors } from "../../services/config/colors"
import { CSSProperties, useState } from "react"
import Title from "./Title"
import "../../styles/select.css"
import { defaultTransition } from "../../services/config/constants"
import chevronDownIcon from "../../assets/icons/chevron-down.svg"

const Select = ({
  options,
  selectedOption,
  onChange,
  popoverWidth = 120,
  style,
  loading,
  disabled,
}: {
  options: string[]
  selectedOption: number
  onChange: (newValue: number) => void
  popoverWidth?: number
  style?: CSSProperties
  loading?: boolean
  disabled?: boolean
}) => {
  // popover logic
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <ButtonBase
        disabled={disabled || loading}
        style={{
          width: "100%",
          height: 49,
          backgroundColor: colors.backgroundWhite,
          borderRadius: 8,
          border: "1px solid " + colors.stroke,
          paddingInline: 16,
          justifyContent: "flex-start",
          position: "relative",
          transition: defaultTransition,
          opacity: disabled ? 0.4 : 1,
          ...style,
        }}
        onClick={handleClick}
      >
        <Title
          fontSize={14}
          style={{
            transition: defaultTransition,
            opacity: loading ? 0.4 : 1,
          }}
        >
          {options[selectedOption]}
        </Title>
        <img
          src={chevronDownIcon}
          style={{
            width: 16,
            height: 16,
            position: "absolute",
            right: 8,
            transition: defaultTransition,
            opacity: loading ? 0.4 : 1,
          }}
        />
      </ButtonBase>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        classes={{ paper: "popover-paper" }}
      >
        <Stack
          style={{
            width: popoverWidth,
          }}
        >
          {options.map((option, index) => (
            <ButtonBase
              key={option}
              className={selectedOption === index ? "" : "select-item"}
              style={{
                width: "100%",
                height: 49,
                paddingLeft: 16,
                justifyContent: "flex-start",
                backgroundColor:
                  selectedOption === index
                    ? colors.backgroundLight
                    : colors.backgroundWhite,
                transition: defaultTransition,
              }}
              onClick={() => {
                onChange(index)
                handleClose()
              }}
              aria-label={option}
            >
              <Title fontSize={14}>{option}</Title>
            </ButtonBase>
          ))}
        </Stack>
      </Popover>
    </>
  )
}

export default Select
